import { ActionType, ResourceType } from './types';

export const DEFAULT_PERMISSION_DENIED_REASON =
  'You do not have permission to perform this action.';

export const actionTypeToMessage = {
  [ActionType.CONNECT]: 'connect',
  [ActionType.CONNECT_EXISTING]: 'connect existing',
  [ActionType.CONNECT_NEW]: 'create and thus to connect new',
  [ActionType.DISCONNECT]: 'disconnect',
  [ActionType.EDIT]: 'edit',
  [ActionType.CREATE_DELETE]: 'create or delete',
  [ActionType.CREATE]: 'create',
  [ActionType.DELETE]: 'delete',
  [ActionType.TEST]: 'test',
  [ActionType.PII_LIVE_EVENTS]: 'view live events for',
  [ActionType.PII_FAILURE_SAMPLES]: 'view samples for',
  [ActionType.PII_RETL_DATA_ACCESS]: 'view clear text for',
} as const;

export const resourceTypeToMessage = {
  [ResourceType.DESTINATION]: {
    singular: 'this destination',
    plural: 'destinations',
    includeAction: true,
  },
  [ResourceType.EVENT_STREAM]: {
    singular: 'this event stream source',
    plural: 'event stream sources',
    includeAction: true,
  },
  [ResourceType.TABLE]: {
    singular: 'this reverse ETL table',
    plural: 'reverse ETL tables',
    includeAction: true,
  },
  [ResourceType.AUDIENCE]: {
    singular: 'this reverse ETL audience',
    plural: 'reverse ETL audiences',
    includeAction: true,
  },
  [ResourceType.SQL_MODEL]: {
    singular: 'this reverse ETL SQL model',
    plural: 'reverse ETL SQL models',
    includeAction: true,
  },
  [ResourceType.EXTRACT]: {
    singular: 'this extract source',
    plural: 'extract sources',
    includeAction: true,
  },
  [ResourceType.RETL]: {
    singular: 'reverse ETL sources',
    plural: 'reverse ETL sources',
    includeAction: true,
  },
  [ResourceType.SOURCE]: {
    singular: 'sources',
    plural: 'sources',
    includeAction: true,
  },
  [ResourceType.DATA_CATALOG]: {
    singular: 'data catalog',
    plural: 'data catalog',
    includeAction: true,
  },
  [ResourceType.TRACKING_PLAN]: {
    singular: 'this tracking plan',
    plural: 'tracking plans',
    includeAction: true,
  },
  [ResourceType.TRANSFORMATION]: {
    singular: 'this transformation',
    plural: 'transformations',
    includeAction: true,
  },
  [ResourceType.TRANSFORMATION_LIBRARY]: {
    singular: 'transformation libraries',
    plural: 'transformation libraries',
    includeAction: true,
  },
  [ResourceType.PROFILES_PROJECT]: {
    singular: 'this profiles project',
    plural: 'profiles projects',
    includeAction: true,
  },
  [ResourceType.RETRY_SYNC]: {
    singular: 'retry syncs',
    plural: 'retry syncs',
    includeAction: false,
  },
  [ResourceType.ALERT_OVERRIDE]: {
    singular: 'modify resource-level alert configuration',
    plural: 'modify resource-level alert configuration',
    includeAction: false,
  },
  [ResourceType.BOT_MANAGEMENT]: {
    singular: 'modify bot management configuration',
    plural: 'modify bot management configuration',
    includeAction: false,
  },
  [ResourceType.EVENT_BLOCKING]: {
    singular: 'modify event blocking configuration',
    plural: 'modify event blocking configuration',
    includeAction: false,
  },
  [ResourceType.CREDENTIAL_STORE]: {
    singular: 'update the credential store',
    plural: 'update the credential store',
    includeAction: false,
  },
  [ResourceType.DATA_GRAPH]: {
    singular: 'the data graph',
    plural: 'the data graph',
    includeAction: true,
  },
} as const;
